import { SvgProps } from "@/utils/types";

export const Stand = ({
  primaryColor = "#D4DF65",
  secondaryColor = "#F66E09",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => (
  <svg
    width="35"
    height="32"
    viewBox="0 0 35 32"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.59557 6.39117H6.12695V17.8295H8.59557V6.39117Z"
      fill={primaryColor}
    />
    <path
      d="M9.42614 18.6216H5.29395V5.59918H9.42614V18.6216ZM6.95753 17.0375H7.76256V7.18399H6.95753V17.0375Z"
      fill={outlineColor}
    />
    <path
      d="M29.232 6.41138H26.7461V17.8497H29.232V6.41138Z"
      fill={primaryColor}
    />
    <path
      d="M30.0667 18.6446H25.9111V5.61639H30.0667V18.6446ZM27.5807 17.054H28.3971V7.20623H27.5807V17.054Z"
      fill={outlineColor}
    />
    <path
      d="M30.358 17.8375H4.82833C3.89624 17.8375 3.14062 18.5573 3.14062 19.4453V28.8363C3.14062 29.7243 3.89624 30.4441 4.82833 30.4441H30.358C31.29 30.4441 32.0457 29.7243 32.0457 28.8363V19.4453C32.0457 18.5573 31.29 17.8375 30.358 17.8375Z"
      fill={primaryColor}
    />
    <path
      d="M30.3588 31.4164H4.82843C3.3352 31.4164 2.12012 30.2589 2.12012 28.8363V19.4452C2.12012 18.0227 3.3352 16.8652 4.82843 16.8652H30.3581C31.8513 16.8652 33.0664 18.0227 33.0664 19.4452V28.8363C33.0664 30.2589 31.8513 31.4164 30.3581 31.4164H30.3588ZM4.82843 18.8097C4.46737 18.8097 4.16134 19.1006 4.16134 19.4452V28.8363C4.16134 29.1803 4.46662 29.4718 4.82843 29.4718H30.3581C30.7191 29.4718 31.0251 29.181 31.0251 28.8363V19.4452C31.0251 19.1013 30.7199 18.8097 30.3581 18.8097H4.82843Z"
      fill={outlineColor}
    />
    <path
      d="M3.30762 6.39117V8.42407C3.51264 9.303 4.32823 9.93563 5.26366 9.94856C6.22096 9.96148 7.06896 9.32311 7.27926 8.42407V6.39117H3.30762Z"
      fill={secondaryColor}
    />
    <path
      d="M5.29338 10.8139C5.27906 10.8139 5.26549 10.8139 5.25117 10.8139C3.88382 10.7952 2.72075 9.88971 2.42225 8.61296L2.40039 8.52033V5.52808H8.18637V8.52033L8.16451 8.61296C7.86526 9.89402 6.66148 10.8146 5.29263 10.8146L5.29338 10.8139ZM4.21473 8.31496C4.35644 8.75873 4.78986 9.07756 5.2768 9.08474C5.28207 9.08474 5.28735 9.08474 5.29263 9.08474C5.78861 9.08474 6.22806 8.76735 6.37128 8.31496V7.25507H4.21397V8.31424L4.21473 8.31496Z"
      fill={outlineColor}
    />
    <path
      d="M7.5459 6.39117V8.42407C7.75093 9.303 8.56651 9.93563 9.50195 9.94856C10.4592 9.96148 11.3072 9.32311 11.5175 8.42407V6.39117H7.5459Z"
      fill={secondaryColor}
    />
    <path
      d="M9.53069 10.8139C9.51636 10.8139 9.5028 10.8139 9.48847 10.8139C8.12113 10.7952 6.95805 9.88971 6.65955 8.61296L6.6377 8.52033V5.52808H12.4237V8.52033L12.4018 8.61296C12.1026 9.89402 10.8988 10.8146 9.52993 10.8146L9.53069 10.8139ZM8.45279 8.31496C8.5945 8.75873 9.02792 9.07756 9.51486 9.08474C9.52013 9.08474 9.52541 9.08474 9.53069 9.08474C10.0259 9.08474 10.4661 8.76735 10.6093 8.31496V7.25578H8.45203V8.31496H8.45279Z"
      fill={outlineColor}
    />
    <path
      d="M11.5176 6.39117V8.42407C11.7226 9.303 12.5382 9.93563 13.4736 9.94856C14.4309 9.96148 15.2789 9.32311 15.4892 8.42407V6.39117H11.5176Z"
      fill={secondaryColor}
    />
    <path
      d="M13.5024 10.8139C13.488 10.8139 13.4745 10.8139 13.4602 10.8139C12.0928 10.7952 10.9297 9.88971 10.6312 8.61296L10.6094 8.52033V5.52808H16.3954V8.52033L16.3735 8.61296C16.0742 9.89402 14.8705 10.8146 13.5016 10.8146L13.5024 10.8139ZM12.4245 8.31496C12.5662 8.75873 12.9996 9.07756 13.4865 9.08474C13.4918 9.08474 13.4971 9.08474 13.5024 9.08474C13.9984 9.08474 14.4378 8.76735 14.581 8.31496V7.25507H12.4237V8.31424L12.4245 8.31496Z"
      fill={outlineColor}
    />
    <path
      d="M15.6084 6.39117V8.42407C15.8134 9.303 16.629 9.93563 17.5644 9.94856C18.5217 9.96148 19.3697 9.32311 19.58 8.42407V6.39117H15.6084Z"
      fill={secondaryColor}
    />
    <path
      d="M17.5922 10.8139C17.5779 10.8139 17.5643 10.8139 17.55 10.8139C16.1826 10.7952 15.0196 9.88971 14.7211 8.61296L14.6992 8.52033V5.52808H20.4852V8.52033L20.4633 8.61296C20.1641 9.89402 18.9603 10.8146 17.5915 10.8146L17.5922 10.8139ZM16.5143 8.31496C16.656 8.75873 17.0894 9.07756 17.5764 9.08474C17.5817 9.08474 17.5869 9.08474 17.5922 9.08474C18.0882 9.08474 18.5276 8.76735 18.6709 8.31496V7.25507H16.5136V8.31424L16.5143 8.31496Z"
      fill={outlineColor}
    />
    <path
      d="M19.5791 6.39117V8.42407C19.7841 9.303 20.5997 9.93563 21.5352 9.94856C22.4924 9.96148 23.3404 9.32311 23.5507 8.42407V6.39117H19.5791Z"
      fill={secondaryColor}
    />
    <path
      d="M21.5639 10.8139C21.5496 10.8139 21.536 10.8139 21.5217 10.8139C20.1543 10.7952 18.9913 9.88971 18.6928 8.61296L18.6709 8.52033V5.52808H24.4569V8.52033L24.435 8.61296C24.1358 9.89402 22.932 10.8146 21.5631 10.8146L21.5639 10.8139ZM20.486 8.31496C20.6277 8.75873 21.0611 9.07756 21.5481 9.08474C21.5533 9.08474 21.5586 9.08474 21.5639 9.08474C22.0599 9.08474 22.4993 8.76735 22.6425 8.31496V7.25507H20.4852V8.31424L20.486 8.31496Z"
      fill={outlineColor}
    />
    <path
      d="M23.5498 6.39117V8.42407C23.7548 9.303 24.5704 9.93563 25.5059 9.94856C26.4631 9.96148 27.3111 9.32311 27.5214 8.42407V6.39117H23.5498Z"
      fill={secondaryColor}
    />
    <path
      d="M25.5356 10.8139C25.5212 10.8139 25.5077 10.8139 25.4934 10.8139C24.126 10.7952 22.9629 9.88971 22.6644 8.61296L22.6426 8.52033V5.52808H28.4286V8.52033L28.4067 8.61296C28.1075 9.89402 26.9037 10.8146 25.5348 10.8146L25.5356 10.8139ZM24.4577 8.31496C24.5994 8.75873 25.0328 9.07756 25.5197 9.08474C25.525 9.08474 25.5303 9.08474 25.5356 9.08474C26.0316 9.08474 26.471 8.76735 26.6142 8.31496V7.25578H24.4569V8.31496H24.4577Z"
      fill={outlineColor}
    />
    <path
      d="M27.7002 6.39117V8.42407C27.9052 9.303 28.7208 9.93563 29.6562 9.94856C30.6135 9.96148 31.4615 9.32311 31.6718 8.42407V6.39117H27.7002Z"
      fill={secondaryColor}
    />
    <path
      d="M29.685 10.8139C29.6707 10.8139 29.6571 10.8139 29.6428 10.8139C28.2754 10.7952 27.1123 9.88971 26.8139 8.61296L26.792 8.52033V5.52808H32.578V8.52033L32.5561 8.61296C32.2569 9.89402 31.0531 10.8146 29.6842 10.8146L29.685 10.8139ZM28.6071 8.31496C28.7488 8.75873 29.1822 9.07756 29.6692 9.08474C29.6744 9.08474 29.6797 9.08474 29.685 9.08474C30.181 9.08474 30.6204 8.76735 30.7636 8.31496V7.25507H28.6063V8.31424L28.6071 8.31496Z"
      fill={outlineColor}
    />
    <path
      d="M31.671 21.6612H3.14062V22.9573H31.671V21.6612Z"
      fill={outlineColor}
    />
    <path
      d="M31.671 25.386H3.14062V26.6821H31.671V25.386Z"
      fill={outlineColor}
    />
    <path
      d="M31.9507 1.75598H3.23562C2.53541 1.75598 1.96777 2.29674 1.96777 2.9638V4.76116C1.96777 5.42822 2.53541 5.96898 3.23562 5.96898H31.9507C32.6509 5.96898 33.2186 5.42822 33.2186 4.76116V2.9638C33.2186 2.29674 32.6509 1.75598 31.9507 1.75598Z"
      fill={primaryColor}
    />
    <path
      d="M31.9511 6.98435H3.23603C1.94934 6.98435 0.902344 5.98693 0.902344 4.76116V2.9638C0.902344 1.73875 1.94934 0.741333 3.23603 0.741333H31.9511C33.2378 0.741333 34.2848 1.73875 34.2848 2.96452V4.76188C34.2848 5.98765 33.2378 6.98507 31.9511 6.98507V6.98435ZM3.23603 2.77135C3.12447 2.77135 3.03327 2.85824 3.03327 2.96452V4.76188C3.03327 4.86816 3.12447 4.95505 3.23603 4.95505H31.9511C32.0627 4.95505 32.1539 4.86816 32.1539 4.76188V2.96452C32.1539 2.85824 32.0627 2.77135 31.9511 2.77135H3.23603Z"
      fill={outlineColor}
    />
    <path
      d="M17.8845 27.4088C19.7791 27.4088 21.315 25.9457 21.315 24.1408C21.315 22.3359 19.7791 20.8728 17.8845 20.8728C15.99 20.8728 14.4541 22.3359 14.4541 24.1408C14.4541 25.9457 15.99 27.4088 17.8845 27.4088Z"
      fill={secondaryColor}
    />
    <path
      d="M17.8841 27.9861C15.6582 27.9861 13.8477 26.2613 13.8477 24.1408C13.8477 22.0203 15.6582 20.2955 17.8841 20.2955C20.11 20.2955 21.9206 22.0203 21.9206 24.1408C21.9206 26.2613 20.11 27.9861 17.8841 27.9861ZM17.8841 21.4502C16.3268 21.4502 15.0597 22.6572 15.0597 24.1408C15.0597 25.6244 16.3268 26.8315 17.8841 26.8315C19.4414 26.8315 20.7085 25.6244 20.7085 24.1408C20.7085 22.6572 19.4414 21.4502 17.8841 21.4502Z"
      fill={outlineColor}
    />
  </svg>
);
